import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import {SnackbarProvider} from "notistack";

import "@fontsource/roboto";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource-variable/roboto-condensed";
import "@fontsource/anton";
import "@fontsource/bebas-neue";
import "@fontsource-variable/inter";
import "@fontsource/lato";
import "@fontsource/libre-baskerville";
import "@fontsource/lobster";
import "@fontsource-variable/lora";
import "@fontsource/merriweather";
import "@fontsource-variable/montserrat";
import "@fontsource-variable/noto-sans";
import "@fontsource-variable/open-sans";
import "@fontsource-variable/oswald";
import "@fontsource/pacifico";
import "@fontsource-variable/playfair-display";
import "@fontsource/poppins";
import "@fontsource-variable/raleway";
import "@fontsource/righteous";
import "@fontsource-variable/roboto-slab";
import "@fontsource/source-sans-pro";
import SnackbarCloseButton from "common/Snackbar/CloseButton";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    {/* <BrowserRouter> */}
    <CssBaseline />
    <SnackbarProvider
      autoHideDuration={5000}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center"
      }}
      preventDuplicate
      maxSnack={2}
      action={ snackbarKey => <SnackbarCloseButton snackbarKey={snackbarKey}/>}
    >
      <App />
    </SnackbarProvider>
    {/* </BrowserRouter> */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals( console.log );
